module.exports = __webpack_public_path__ + "img/用户.6b0a02f2.png";